export interface UpdateCorporationDto {
  /**
   * minLength: 0
   * maxLength: 200
   */
  name: string;

  /**
   * minLength: 0
   * maxLength: 1000
   */
  description?: string;

  /**
   * minLength: 0
   * maxLength: 320
   */
  email: string;

  /**
   * minLength: 0
   * maxLength: 20
   */
  phone?: string;

  /**
   * format: uri
   * minLength: 0
   * maxLength: 500
   */
  website?: string;

  /**
   * format: uri
   * minLength: 0
   * maxLength: 500
   */
  logoUrl?: string;

  /**
   * minLength: 0
   * maxLength: 500
   */
  addressLine1?: string;

  /**
   * minLength: 0
   * maxLength: 500
   */
  addressLine2?: string;

  /**
   * minLength: 0
   * maxLength: 100
   */
  city?: string;

  /**
   * minLength: 0
   * maxLength: 50
   */
  state?: string;

  /**
   * minLength: 0
   * maxLength: 20
   */
  postalCode?: string;

  /**
   * minLength: 0
   * maxLength: 100
   */
  country?: string;

  /**
   * minLength: 0
   * maxLength: 50
   */
  timeZone?: string;

  /**
   * minLength: 0
   * maxLength: 500
   */
  businessHours?: string;

  isActive?: boolean;
}
